import { NavLink } from "react-router-dom";
import posthog from "posthog-js";

const fmt = (d) =>
  new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

/**
 * badge: "start" | "new" | null — decided by the parent from server flags.
 */
const ClubEpisodeRow = ({ episode, number, badge, clubGuid }) => {
  const pivot = episode.pivot || {};
  const title = pivot.title || episode.title;
  const img = pivot.featured_image || episode.featured_image;
  const locked = !episode.released;
  const href = `/listener-episode/${pivot.podcast_club_id}/${pivot.podcast_episode_id}`;

  const status = locked
    ? <span className="lpc-row__status">Releases {pivot.start_date_time ? fmt(pivot.start_date_time) : "soon"}</span>
    : badge
      ? <span className="lpc-badge">{badge === "start" ? "Start here" : "New"}</span>
      : <span className="lpc-row__status">{pivot.start_date_time ? fmt(pivot.start_date_time) : ""}</span>;

  const className = `lpc-row${locked ? " lpc-row--locked" : ""}${badge === "start" ? " lpc-row--start" : ""}`;

  const body = (
    <>
      <span className="lpc-row__num">{number}</span>
      {img
        ? <img className="lpc-row__thumb" src={img} alt="" />
        : <span className="lpc-row__thumb lpc-row__thumb--empty" />}
      <span className="lpc-row__body">
        <span className="lpc-row__title">{title}</span>
        {episode.teaser && <span className="lpc-row__teaser">{episode.teaser}</span>}
      </span>
      {status}
    </>
  );

  if (locked) {
    return <div className={className} aria-disabled="true">{body}</div>;
  }

  return (
    <NavLink
      className={className}
      to={href}
      onClick={() => posthog.capture("club_episode_row_clicked", {
        club_guid: clubGuid, episode_pivot_id: pivot.id, badge: badge || "none",
      })}
    >
      {body}
    </NavLink>
  );
};

export default ClubEpisodeRow;
